// import blog from './blog'
import account from "./account";
import common from "./common";
import store from "./store";

export default {
  //   blog,
  account,
  common,
  store,
};
